import { useEffect, useState } from "react";
import api from "../../services/api";
import useWrapper from "../useWrapper";

const useCostCenter = props => {
  const query = props?.query || "";
  const { config } = useWrapper();

  const [costCenter, setcostCenter] = useState();
  useEffect(() => {
    (async () => {
      const { data: _cost_center } = await api.get(`cost-center${query}`, config);
      setcostCenter(
        _cost_center.map(__cost_center => ({
          value: __cost_center.id,
          label: __cost_center.name,
          expensePlan: __cost_center.expensePlan.map(__expense_plan => ({
            value: __expense_plan.id,
            label: __expense_plan.name,
            expenses: __expense_plan.expenses.map(__expense => ({
              value: __expense.id,
              label: __expense.name,
            })),
          })),
        })),
      );
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render (src/context/WrapperContext.jsx, outside this file's scope); adding it would refire this fetch on unrelated context updates. `query` is included so callers passing a dynamic query still refetch correctly.
  }, [query]);

  return costCenter;
};

export default useCostCenter;
